<template>
  <footer>
    <div class="container">
      <router-link class="logo-font" :to="{ name: 'home', params: {} }">
        LinkUp
      </router-link>
      <span class="attribution">
        Copyright &copy;{{ new Date().getFullYear() }} All rights reserved | Design by Yunus Emre Alpu
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "RwvFooter"
};
</script>
